module.exports = __webpack_public_path__ + "img/03.3b993a6c.jpg";